<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('catalogue.produitConcessionnaire.title') }}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-12">
          <button class="is-pulled-right button is-primary"
                  @click="addLigneProduitConcesssion">
            {{ $t('catalogue.produitConcessionnaire.actions.add') }}
          </button>
        </div>
        <div class="column is-12">
          <div class="has-text-centered has-background-background pdt-20px pdb-20px"
               v-if="produit.produitsConcessionnaire.length === 0">
            <h1 class="title is-size-4">
              {{ $t('catalogue.produitConcessionnaire.tab.noConcession')}}
            </h1>
          </div>
          <div v-else>
            <div class="columns is-multiline">
              <div class="column is-12 pdb-0 ligneProduitHeader">
                <div class="columns is-marginless is-paddingless">
                  <div class="label column is-4 has-text-black">
                    {{ $t('catalogue.produitConcessionnaire.tab.bailleur') }}
                  </div>
                  <div class="label column is-4 has-text-black">
                    {{ $t('catalogue.produitConcessionnaire.tab.pourcentage') }}
                  </div>
                </div>
              </div>
              <div class="column is-12 pdt-0"
                   v-for="(ligne, index) in produit.produitsConcessionnaire"
                   :key="index">
                <ligne-produit-concessionnaire
                  :ligne="ligne"
                  :produitsConcessionnaire="produit.produitsConcessionnaire"
                  @deleteLigne="deleteLigne(index)">
                </ligne-produit-concessionnaire>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import genererProduitConcessionnaire
  from '@/services/catalogue/commun/genererProduitConcessionnaire';
import ligneProduitConcessionnaire
  from '@/components/bodac/produit/produitConcessionnaire/ajout/ligneProduitConcessionnaire';

export default {
  props: {
    produit: {
      required: true,
      type: Object,
    },
  },
  components: {
    ligneProduitConcessionnaire,
  },
  methods: {
    addLigneProduitConcesssion() {
      this.produit.produitsConcessionnaire.push(genererProduitConcessionnaire());
    },
    deleteLigne(index) {
      const lignes = cloneDeep(this.produit.produitsConcessionnaire);
      lignes.splice(index, 1);
      this.produit.produitsConcessionnaire = cloneDeep(lignes);
    },
  },
};

</script>
